import React from "react";

const PageLoader = () => {
  return (
    <div className="col-md-12 p-lg-5 mx-auto text-center">
      <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
        <span className="visually-hidden">Chargement...</span>
      </div>
      <p className="mt-3 text-muted">Chargement en cours...</p>
    </div>
  );
};

export default PageLoader;